import { getContentCategories } from '@/services/content-categories'
import useQuery from './useQuery'

type UseContentCategoriesOptions = {
  projectId: string | undefined
  refetchOnWindowFocus?: boolean
}

export default function useContentCategories({
  projectId,
  refetchOnWindowFocus = false,
}: UseContentCategoriesOptions) {
  const query = useQuery({
    queryKey: ['content-categories', projectId],
    queryFn: () =>
      getContentCategories(projectId as string).then(
        ({ data }) => data.results,
      ),
    enabled: !!projectId,
    refetchOnWindowFocus,
  })

  return {
    ...query,
    categoriesContent: query.data,
  }
}
